/**
 * Image taxonomy classify — short Object / Layers labels via bgremove → PhotoStudio.
 */
import apiClient, { createAuthConfig } from "../client";
import { prepareImageForClassify } from "../../../utils/prepareImageForAi";

/**
 * @param {string} token
 * @param {File|Blob} imageFile
 * @param {{ topK?: number }} [options]
 * @returns {Promise<{ success: boolean, label: string, score?: number, raw_label?: string }>}
 */
export async function classifyImage(token, imageFile, options = {}) {
  const prepared = await prepareImageForClassify(imageFile);
  const formData = new FormData();
  formData.append("file", prepared, prepared.name || "image.jpg");
  if (options.topK != null) {
    formData.append("top_k", String(options.topK));
  }
  const response = await apiClient.post("/api/classify", formData, {
    ...createAuthConfig(token),
    timeout: 60000,
    headers: {
      ...createAuthConfig(token).headers,
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export default { classifyImage };
